import { QueryParams } from "Shared/queries/consts"

import { PurchaseOrderStatusEnum } from "@finway-group/shared/lib/models"

export const defaultFilterInvoiceLink = { "state.currentState": { in: [PurchaseOrderStatusEnum.FULFILLMENT] } }
export const defaultQueryParamsInvoiceLink: QueryParams = {
    page: 1,
    limit: 5,
    search: "",
}

export const defaultFilterDeliveryNoteLink = { "state.currentState": { in: [PurchaseOrderStatusEnum.FULFILLMENT] }, isService: { nis: true } }
